import { RoleDTO } from './RoleDTO';

export class OrganisationMemberDTO {

    Id: string;
    UserId: string;
    Status: string;
    Title: string;
    FirstName: string;       
    LastName: string;        
    ExternalId: string;
    Email: string;
    Mobile: string;
    Language: string;
    Gender: number;
    DateOfBirth: Date;
    SMSAlias: string;
    EmailAlias: string;
    Roles: RoleDTO[];
    IsEnabledOrganisationAftercareSettings: boolean;
}


